import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CancelOrderService } from '../../services/cancel-order.service';
import { CancelOrder, CancelOrderGarment } from '../../models/cancel-order.model';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
@Component({
    selector: 'app-employee-cancel-order-page',
    templateUrl: 'department-cancel-order.page.html',
    styleUrls: [
      './department-cancel-order.page.scss',
    ]
  })
  export class DepartmentCancelOrderPage implements OnInit {
stopCode:string;
    constructor(
      private router: Router,
      private route: ActivatedRoute,
       public authService: GtrakAuthService,
      private cancelOrderService: CancelOrderService,
    ) { }
    requestParams:any;
    cancelOrders: any[] = [];
    totalLossCharge: number = 0;
    loaded: boolean=false;
    header:string;
    deptId:string;
    customerId:string;
    employeeCode:string;
    customerName:string;
    departmentName:string;
    isStopPage:boolean=false;
    currentDate = new Date();
    headerItems:any[]=[];
    public viewChange: boolean = false;
    async ngOnInit() {
      this.loaded = false;
      this.requestParams = new RequestParams();
      this.stopCode = this.route.snapshot.paramMap.get('sid');
      this.customerId=this.route.snapshot.params.cid;
      if(this.authService.user.isCostCenterUser){
        this.requestParams.filters.CostCenterUser=localStorage.getItem('CostCenterUser');
      }
        if(this.stopCode!=undefined ||this.stopCode!=null){
          this.header='Stop Cancel Order';
          this.isStopPage=true;
          this.deptId= this.route.snapshot.params.did;
          this.employeeCode=this.route.snapshot.paramMap.get('ep');
          await this.cancelOrderService.getForStopCode(this.route.snapshot.params.cid, this.stopCode, this.requestParams).then((cancelOrder) => {
          this.cancelOrders = cancelOrder;
        });
      
            }
        else{
          await this.cancelOrderService.getForDepartment(this.route.snapshot.params.id, this.route.snapshot.params.cid, this.requestParams).then((cancelOrder) => {
          this.cancelOrders = cancelOrder;
          this.isStopPage=false;
          this.header='Department Cancel Order';
            this.deptId= this.route.snapshot.params.id;

        });
        }
        if(this.cancelOrders!=undefined){
          if(this.cancelOrders.length>0){
            
            if(this.cancelOrders[0].length>0){
              this.customerName=this.cancelOrders[0][0].customerName;
              this.departmentName=this.cancelOrders[0][0].departmentName;
              }
          }
        for (let i = 0; i < this.cancelOrders.length; i++) {
                let woLossCharge = 0;
                const cancelOrderGarments = this.cancelOrders[i] as unknown as CancelOrderGarment[];
                for (let j = 0; j < cancelOrderGarments.length; j++) {
                  if(cancelOrderGarments[j].dateCollected === null) {
                    woLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
                    this.totalLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
                    woLossCharge = Math.round(woLossCharge * 100) / 100;
                    this.totalLossCharge = Math.round(this.totalLossCharge * 100) / 100;
                  }
                }
                this.cancelOrders[i].lossCharge = woLossCharge;
              }
            }
              this.loaded = true;
    }
 changePrinterView(): void {
    this.viewChange = !this.viewChange;
    setTimeout(() => {
      print();
    }, 1000); 
  }
   
  }